module.exports = __webpack_public_path__ + "static/img/2.43a44ed.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/4/eng/2.png
// module id = 4Hm4
// module chunks = 0